import { gql } from '@apollo/client';

export const GET_CUENTO_ID = gql`
  {
    getCuentoId @client
  }
`;

export const GET_CUENTO = gql`
  query getCuento($id: ID!) {
    getCuento(id: $id) {
      _id
      titulo
      autor
      resumen
      contenido
    }
  }
`;

export const GET_CUENTOS = gql`
  query getCuentos($paginate: getCuentosPaginate!) {
    getCuentos(paginate: $paginate) {
      cuentos {
        node {
          _id
          titulo
          autor
          resumen
          contenido
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const SEARCH_CUENTOS = gql`
  query searchCuentos($paginate: searchCuentosPaginate!) {
    searchCuentos(paginate: $paginate) {
      cuentos {
        node {
          _id
          titulo
          autor
          resumen
          contenido
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const ADD_CUENTO = gql`
  mutation createCuento($input: CreateCuentoInput!) {
    createCuento(input: $input) {
      _id
      titulo
      autor
      resumen
      contenido
      code
      success
      message
    }
  }
`;

export const UPDATE_CUENTO = gql`
  mutation updateCuento($input: UpdateCuentoInput) {
    updateCuento(input: $input) {
      _id
      titulo
      autor
      resumen
      contenido
      code
      success
      message
    }
  }
`;

export const REMOVE_CUENTO = gql`
  mutation removeCuento($input: DeleteCuentoInput!) {
    removeCuento(input: $input) {
      code
      success
      message
    }
  }
`;
